export type Group<T> = { [key: string]: T[] };

export const groupBy = <T>(
  array: T[],
  // eslint-disable-next-line no-unused-vars
  getKey: (value: T) => string,
): Group<T> => {
  const accumulator: Group<T> = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const value of array) {
    const key = getKey(value);
    const group = accumulator[key] || [];
    accumulator[key] = [...group, value];
  }
  return accumulator;
};

export const collect = <T, U>(
  group: Group<T>,
  // eslint-disable-next-line no-unused-vars
  map: (key: string, value: T[]) => U,
): U[] => {
  let accumulator: U[] = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(group)) {
    const mapped = map(key, value);
    accumulator = [...accumulator, mapped];
  }
  return accumulator;
};
